import React from 'react';

import '../App.css';

import { useEffect } from 'react';
import { getAppInsights } from '../AppInsights';



interface ListPointProps { title: string, text: string };
const ListPoint: React.FC<ListPointProps> = ({ title, text }) => {
    return <li> <b>{title}</b>
        <p>{text}</p>
    </li>;
}

const Main = () => {

    const appInsights = getAppInsights();
    useEffect(() => {
        appInsights?.trackPageView({ name: "Privacy" });
    }, []);

    return (
        <>
            <h2>Support</h2>
            <p>Coming soon...</p>
        </>
    );
}

export default Main;
